module.exports = __webpack_public_path__ + "img/20240110074419606a3d.1e6419df.jpg";